import { Icon, Spinner } from '@blueprintjs/core';
import * as React from 'react';

import { LabeledCard } from 'src/components/cards/LabeledCard';
import { TEST_IDS } from 'src/constants/testIds';
import { ConnectionMenu } from 'src/containers/ConnectionMenu/ConnectionMenu';
import { connectionSelector } from 'src/selectors/connection';
import { isConnectedSelector } from 'src/selectors/isConnected';
import { isConnectingSelector } from 'src/selectors/isConnecting';
import * as copy from 'src/templates/copy';
import { icons } from 'src/templates/icons';
import { colors } from 'src/templates/styles/colors';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

type ConnectionCardProps = {
  disabled?: boolean;
};

export const ConnectionCard: React.VFC<ConnectionCardProps> = ({
  disabled = false,
}) => {
  const connection = useReduxSelector(connectionSelector);
  const isConnected = useReduxSelector(isConnectedSelector);
  const isConnecting = useReduxSelector(isConnectingSelector);

  const cardContent = isConnecting ? (
    <Spinner />
  ) : (
    <>
      <Icon
        color={isConnected ? colors.darkIcon : undefined}
        icon={icons.connection}
      />
      <div className="sd-connection-card__label">
        {connection && isConnected
          ? connection.name
          : copy.components.cards.connection.placeholder}
      </div>
    </>
  );

  return (
    <ConnectionMenu disabled={isConnecting || disabled}>
      <LabeledCard
        disabled={isConnecting || disabled}
        label={copy.components.cards.connection.label}
        labelClassName="sd-connection-card"
        testId={TEST_IDS.connection.card}
      >
        {cardContent}
      </LabeledCard>
    </ConnectionMenu>
  );
};
